import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

import { Spin } from 'ant-design-vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    loading: { type: Boolean, default: true },
    width: {},
    height: {},
    className: {}
  },
  setup(__props: any) {

/*
 * @author: Lew
 * @e-mail: yaol@jiguang.cn
 * @date: 2022/08/05 16:49:13
 * @description: 异步加载组件
 */


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Spin), {
    spinning: _ctx.loading,
    style: {"height":"100%"}
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle({
        width: `${_ctx.width ? `${_ctx.width}px` : '100%'}`,
        height: `${_ctx.height ? `${_ctx.height}px` : '100%'}`,
      })
          }, null, 4))
        : _renderSlot(_ctx.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["spinning"]))
}
}

})